import { contentfulGQLClient } from '../../Common/utils/contentful';
import { isDoctorPortal } from '../../Common/utils/isDoctorPortal';
import { graphql } from '../../__generated__';
import { useQuery } from '@apollo/client';

export const useQuickReplies = (brand: string) => {
  const showQuickReply = isDoctorPortal();

  const { data } = useQuery(
    graphql(`
      query quickRepliesQuery($brand: [String]) {
        quickRepliesCollection(where: { brand_in: $brand }) {
          items {
            reply
            name
          }
        }
      }
    `),
    {
      client: contentfulGQLClient,
      fetchPolicy: 'cache-first',
      variables: {
        brand: [brand, 'all'],
      },
      skip: !showQuickReply,
    },
  );

  // @ts-ignore
  const replies = (data?.quickRepliesCollection?.items ?? []).reduce(
    (a: any[], v: any) => ({ ...a, [v.name]: v.reply }),
    {},
  );

  // @ts-ignore
  const repliesKeys = Object.keys(replies).sort((a, b) => a.localeCompare(b));

  return { replies, repliesKeys, showQuickReply };
};
